
















import { Component, Prop, Vue } from "vue-property-decorator";

import { ImportantMessageInterface } from "@/interfaces/important-message.interface";

@Component({})
export default class ImportantMessageArea extends Vue {
  @Prop({ required: true }) messages!: ImportantMessageInterface[];
}
